<template>
	<div class="row">
		<div class="col-md-12">
			<budgets-datatable
				ref="datatable"
				@reload="reload"
				:project="item"
				:user="user"
				:isAuth="isAuth">
			</budgets-datatable>
		</div>
	</div>
</template>

<script>
	import BudgetsDatatable from '@/components/management/budgets/views/Datatable.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'budgets-datatable': BudgetsDatatable,
		},
		data () {
			return {
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Budgets.vue